<template>
    <div class="position-relative">
        <!-- Begin Page Content -->
        <div class="Analyze-section">
            <div class="row mb-4">
                <div class="col-md-3 col-12">
                    <div class="card border-0 bg-white border-radius-5 h-100">
                        <div class="card-body p-0">
                            <div class="Serum-Electrolytes text-center mt-4">
                                <h4>Biomarkers History</h4>
                                <figure class="overall-health">
                                    <a href="#"><img src="../../../../static/website/images/overall-health.png" alt="" /></a>
                                </figure>
                                <h6 class="last-week">+ 0.3 since last week</h6>
                                <ul class="Serum mb-3 mt-3">
                                    <li class="d-flex justify-content-between">
                                        <p>Patient</p>
                                        <p>Male, 46 years</p>
                                    </li>
                                    <li class="d-flex justify-content-between">
                                        <p>Last Tested Date</p>
                                        <p>07.02.2020</p>
                                    </li>
                                </ul>
                                <div class="button-Download d-flex justify-content-between">
                                    <a href="#" class="btn Download mr-1"><i class="icon icon-download"></i> Download</a>
                                    <a href="#" class="btn Download ml-1"><i class="icon icon-mail"></i> Email</a>
                                </div>
                            </div>
                            <div class="general-clincal">
                                <h3 class="General">General Clinical Research</h3>
                                <ul class="research-area mb-0 General-Clinical" role="tablist">
                                    <li class="d-flex justify-content-between border-top">
                                        <router-link to="/analyze-report" class="nav-lank d-flex align-items-center">Complete Blood Count</router-link >

                                    </li>
                                    <li class="d-flex justify-content-between border-top">
                                        <router-link to="/pre-diabetes" class="nav-lank d-flex align-items-center"><span class="red"></span>Pre-Diabetes or Metabolic Syndrome</router-link>
                                    </li>
                                    <li class="d-flex justify-content-between border-top border-bottom">
                                        <router-link to="/serum-electrolytes" class="nav-lank d-flex align-items-center"><span class="yellow"></span>Serum Electrolytes</router-link>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="col-md-9 col-12">
                    <div class="card border-0 bg-white border-radius-5 h-100">
                        <div class="card-bodytext-center text-center p-4">
                            <div class="Patient-Information row no-gutters justify-content-between border-bottom pb-1 mb-3">
                                <div class="col-lg-3">
                                    <h2 class="mb-0 text-left">Patient Information</h2>
                                    <p class="mb-0 text-left">Jone Doe</p>
                                    <p class="mb-0 text-left">123 WARREN AVE</p>
                                    <p class="mb-0 text-left">TUSTIN CA 123</p>
                                    <p class="mb-0 text-left">(123) 456 - 789</p>
                                </div>
                                <div class="col-lg-3">
                                    <p class="mb-0 text-left"><strong>Provider ID</strong> 0000</p>
                                    <p class="mb-0 text-left">Dr, Sabnam Das</p>
                                    <p class="mb-0 text-left">17323 32rd Ave</p>
                                    <p class="mb-0 text-left">Lake Oswego OR 29384</p>
                                    <p class="mb-0 text-left">Ph: xxx-xxx-xxxx</p>
                                </div>
                            </div>
                            <div class="Patient-details row no-gutters justify-content-between border-bottom pb-1 mb-3">
                                <div class="col text-left">
                                    <ul class="mb-0">
                                        <li>
                                            <p><span class="d-block">Patient Name</span> Jane Doe</p>
                                        </li>
                                        <li>
                                            <p><span class="d-block">DOB</span> 3/4/1994</p>
                                        </li>
                                        <li>
                                            <p><span class="d-block">Age</span> 23 years</p>
                                        </li>
                                        <li>
                                            <p><span class="d-block">Gender</span> f</p>
                                        </li>
                                    </ul>
                                </div>
                                <div class="col text-left">
                                    <ul class="mb-0">
                                        <li>
                                            <p><span class="d-block">Patient ID</span> JD29320129</p>
                                        </li>
                                        <li>
                                            <p><span class="d-block">Report Date and Time</span> 10/26/2020, 12:00</p>
                                        </li>
                                        <li>
                                            <p><span class="d-block">Received Date and Time</span> 11/09/2020, 16:00</p>
                                        </li>
                                        <li>
                                            <p><span class="d-block">Specimen Collection Date and Time</span> Blood Spot 10/13/2020, 8:40</p>
                                        </li>
                                    </ul>
                                </div>
                                <div class="col text-left">
                                    <ul class="mb-0">
                                        <li>
                                            <p><span class="d-block">Hours of Fasting</span> Not Indicated</p>
                                        </li>
                                        <li>
                                            <p><span class="d-block">Family History of Heart Disease</span> Yes</p>
                                        </li>
                                        <li>
                                            <p><span class="d-block">Diabetes</span> No</p>
                                        </li>
                                        <li>
                                            <p><span class="d-block">Smoking</span> Non-smoker</p>
                                        </li>
                                    </ul>
                                </div>
                                <div class="col text-left">
                                    <ul class="mb-0">
                                        <li>
                                            <p><span class="d-block">Waist</span> 26 in</p>
                                        </li>
                                        <li>
                                            <p><span class="d-block">26 in</span> None Indicated</p>
                                        </li>
                                        <li>
                                            <p><span class="d-block">BMI</span> 19.2</p>
                                        </li>
                                        <li>
                                            <p><span class="d-block">Cancer</span> Yes</p>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                            <div class="overall-health row no-gutters">
                                <div class="col-md-12 text-left">
                                    <h2>Overall Health Result</h2>
                                    <figure><img src="../../../../static/website/images/overall-health-result.png" alt="" /></figure>
                                    <h3 class="p-0">Your Top 3 Health Goals</h3>
                                    <p>
                                        To recap, Gini’s 3 month health plan, curated for you by Doctor Shabnam Das Kar, will focus on improving the following 3 health goals you have indicated as your top focuses in your
                                        consultation and intake questionnaire.
                                    </p>
                                    <ul class="d-flex Reduce-Blood justify-content-between">
                                        <li><a href="#">1. Reduce Blood Sugar Levels</a></li>
                                        <li><a href="#">2. Stop Acid Reflux</a></li>
                                        <li><a href="#">3. Weight Loss</a></li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- End of Page Wrapper -->
    </div>
</template>
<script>
    export default {
        name: "Overall-health",
        data() {
            return {};
        },
        created(){
           this.pageName('Overall Health')
        }
    };
</script>



// WEBPACK FOOTER //
// src/components/website/test_report/overall-health.vue